import { ReactComponent as TransactionsDark } from "./transactions-dark-icon.svg";

const TransactionsDarkIcon: React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined;
  }
> = (props) => <TransactionsDark {...props} />;

export default TransactionsDarkIcon;
